import React, { useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function RequireAuth({ children, requireAdmin = false }) {
  const { user, ready } = useAuth();
  const location = useLocation();
  // Stable state object so `<Navigate>` doesn't re-render its consumers on every parent tick.
  const navState = useMemo(() => ({ from: location.pathname }), [location.pathname]);
  if (!ready) return null; // brief flash prevented
  if (!user) {
    return <Navigate to="/login" state={navState} replace />;
  }
  if (requireAdmin && user.role !== 'admin') {
    return <Navigate to="/" replace />;
  }
  return children;
}
